<template>
  <div class="boss-vertical-menu">
    <div
      class="boss-content-sidemenu-title"
      data-test="search-condition-count-label"
      style="font-size: 0.8125rem;"
    >
      保存した検索条件({{ search_conditions.length }}件)
    </div>
    <template v-for="(searchCondition, i) in search_conditions">
      <search-condition-item
        :key="`${searchCondition.id}-${i}`"
        :search-condition="searchCondition"
        :job-id="jobId"
        :contract-id="contractId"
        :is-selected="doSearch && searchCondition.id === Number(membersSearchCondition(jobId).id)"
        @onRead="onRead"
        @updateOften="updateOften"
        @fetchSearchConditions="fetchSearchConditions"
        @refresh="$emit('refresh')"
      />
    </template>
  </div>
</template>

<script>
import SearchConditionItem from '@/components/molecules/SearchConditionItem'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    SearchConditionItem
  },
  props: {
    jobId: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    doSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search_conditions: []
    }
  },
  computed: {
    ...mapGetters([
      'membersSearchCondition'
    ])
  },
  watch: {
    jobId: {
      handler: 'fetchSearchConditions',
      immediate: true
    }
  },
  methods: {
    fetchSearchConditions () {
      // v-forのkeyが変更されないため一旦から更新（foundationのモーダルをSearchConditionItemでjqueryで消したりしているため）
      this.$set(this, 'search_conditions', [])
      this.$http.secured.get(`/scout/view/scouts/jobs/${this.jobId}/search_conditions`)
        .then(response => {
          this.$set(this, 'search_conditions', response.data.map(data => {
            return { ...data, isNew: false }
          }))
          _(this.search_conditions).filter('isOftenUse').value().map(searchCondition => {
            this.$http.secured.get(`/scout/view/scouts/contracts/${this.contractId}/search_conditions/${searchCondition.id}/_is_new`).then(response => {
              this.updateSearchConditionNew(searchCondition.id, response.data)
            })
          })
          this.$store.dispatch('contracts/setSearchConditionId', {
            value: this.search_conditions.length > 0 ? this.search_conditions[0].id : 0,
            jobId: this.jobId
          })
        })
    },
    orderSearchCondition () {
      this.$set(this, 'search_conditions', _.orderBy(this.search_conditions, ['isOftenUse', 'updateDate'], ['desc', 'desc']))
      this.$store.dispatch('contracts/setSearchConditionId', { value: this.search_conditions[0].id, jobId: this.jobId })
    },
    // 検索条件の新着を非表示にするため
    onRead (searchConditionId) {
      this.updateSearchConditionNew(searchConditionId, false)
      this.$emit('fetch')
    },
    updateSearchConditionNew (searchConditionId, isNew) {
      const index = _.findIndex(this.search_conditions, searchCondition => searchCondition.id === searchConditionId)
      const searchCondition = this.search_conditions[index]
      searchCondition.isNew = isNew
      this.$set(this.search_conditions, index, searchCondition)
    },
    updateOften (searchConditionId, isOftenUse) {
      this.$http.secured.put(`scout/view/scouts/jobs/${this.jobId}/search_conditions/${searchConditionId}/often_use`, !isOftenUse)
        .then(response => {
          const index = _.findIndex(this.search_conditions, searchCondition => searchCondition.id === searchConditionId)
          const searchCondition = this.search_conditions[index]
          searchCondition.isOftenUse = !isOftenUse
          this.$set(this.search_conditions, index, searchCondition)
          this.orderSearchCondition()
        })
    }
  }
}
</script>
